import { INSTALLER_UNRESTRICTED_ROLES } from 'config/constants';

export const permissionByWorkroomId = (role, workrooms, employee = null) => {
  const employeeWorkrooms = (employee && employee.workrooms) || [];
  if (role !== 'workroom' || (employeeWorkrooms.length && workrooms.some(i =>
    employeeWorkrooms.some(x => x.id === i.id)))) return true;
  return false;
};

export const permissionByWorkroomName = (role, workrooms, employeeWorkrooms) => {
  if (INSTALLER_UNRESTRICTED_ROLES.includes(role)) return true;
  const employeeWorkroomNames = [];
  if (employeeWorkrooms && employeeWorkrooms.length > 0) {
    employeeWorkrooms.forEach(w => employeeWorkroomNames.push(w.name));
  }
  return employeeWorkroomNames.length > 0 &&
    employeeWorkroomNames.some(w => workrooms.includes(w));
};



// WEBPACK FOOTER //
// ./client/app/utils/permissionUtils.js